export default __webpack_public_path__ + "static/media/acct-report-header.283ab9ff.png";